/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AppUserDto } from '../models/app-user-dto';
import { usersChangePasswordPost } from '../fn/users/users-change-password-post';
import { UsersChangePasswordPost$Params } from '../fn/users/users-change-password-post';
import { usersGet$Json } from '../fn/users/users-get-json';
import { UsersGet$Json$Params } from '../fn/users/users-get-json';
import { usersGet$Plain } from '../fn/users/users-get-plain';
import { UsersGet$Plain$Params } from '../fn/users/users-get-plain';
import { usersUserIdGet$Json } from '../fn/users/users-user-id-get-json';
import { UsersUserIdGet$Json$Params } from '../fn/users/users-user-id-get-json';
import { usersUserIdGet$Plain } from '../fn/users/users-user-id-get-plain';
import { UsersUserIdGet$Plain$Params } from '../fn/users/users-user-id-get-plain';
import { usersUserIdPut$Json } from '../fn/users/users-user-id-put-json';
import { UsersUserIdPut$Json$Params } from '../fn/users/users-user-id-put-json';
import { usersUserIdPut$Plain } from '../fn/users/users-user-id-put-plain';
import { UsersUserIdPut$Plain$Params } from '../fn/users/users-user-id-put-plain';
import { usersUserIdSetActivePost } from '../fn/users/users-user-id-set-active-post';
import { UsersUserIdSetActivePost$Params } from '../fn/users/users-user-id-set-active-post';

@Injectable({ providedIn: 'root' })
export class UsersApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usersUserIdGet()` */
  static readonly UsersUserIdGetPath = '/users/{userId}';

  /**
   * Get user.
   *
   * Returns a user profile by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdGet$Plain$Response(params: UsersUserIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AppUserDto>> {
    const obs = usersUserIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get user.
   *
   * Returns a user profile by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdGet$Plain(params: UsersUserIdGet$Plain$Params, context?: HttpContext): Observable<AppUserDto> {
    const resp = this.usersUserIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AppUserDto>): AppUserDto => r.body)
    );
  }

  /**
   * Get user.
   *
   * Returns a user profile by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdGet$Json$Response(params: UsersUserIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AppUserDto>> {
    const obs = usersUserIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get user.
   *
   * Returns a user profile by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdGet$Json(params: UsersUserIdGet$Json$Params, context?: HttpContext): Observable<AppUserDto> {
    const resp = this.usersUserIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AppUserDto>): AppUserDto => r.body)
    );
  }

  /** Path part for operation `usersUserIdPut()` */
  static readonly UsersUserIdPutPath = '/users/{userId}';

  /**
   * Update user profile.
   *
   * Updates display name and other profile properties.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usersUserIdPut$Plain$Response(params: UsersUserIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AppUserDto>> {
    const obs = usersUserIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update user profile.
   *
   * Updates display name and other profile properties.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usersUserIdPut$Plain(params: UsersUserIdPut$Plain$Params, context?: HttpContext): Observable<AppUserDto> {
    const resp = this.usersUserIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AppUserDto>): AppUserDto => r.body)
    );
  }

  /**
   * Update user profile.
   *
   * Updates display name and other profile properties.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usersUserIdPut$Json$Response(params: UsersUserIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AppUserDto>> {
    const obs = usersUserIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update user profile.
   *
   * Updates display name and other profile properties.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usersUserIdPut$Json(params: UsersUserIdPut$Json$Params, context?: HttpContext): Observable<AppUserDto> {
    const resp = this.usersUserIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AppUserDto>): AppUserDto => r.body)
    );
  }

  /** Path part for operation `usersGet()` */
  static readonly UsersGetPath = '/users';

  /**
   * Search users.
   *
   * Searches for users by text with paging.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGet$Plain$Response(params?: UsersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppUserDto>>> {
    const obs = usersGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search users.
   *
   * Searches for users by text with paging.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGet$Plain(params?: UsersGet$Plain$Params, context?: HttpContext): Observable<Array<AppUserDto>> {
    const resp = this.usersGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AppUserDto>>): Array<AppUserDto> => r.body)
    );
  }

  /**
   * Search users.
   *
   * Searches for users by text with paging.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGet$Json$Response(params?: UsersGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppUserDto>>> {
    const obs = usersGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search users.
   *
   * Searches for users by text with paging.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGet$Json(params?: UsersGet$Json$Params, context?: HttpContext): Observable<Array<AppUserDto>> {
    const resp = this.usersGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AppUserDto>>): Array<AppUserDto> => r.body)
    );
  }

  /** Path part for operation `usersChangePasswordPost()` */
  static readonly UsersChangePasswordPostPath = '/users/change-password';

  /**
   * Change password.
   *
   * Allows the current user to change their password.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersChangePasswordPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usersChangePasswordPost$Response(params?: UsersChangePasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = usersChangePasswordPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change password.
   *
   * Allows the current user to change their password.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersChangePasswordPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usersChangePasswordPost(params?: UsersChangePasswordPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.usersChangePasswordPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usersUserIdSetActivePost()` */
  static readonly UsersUserIdSetActivePostPath = '/users/{userId}/set-active';

  /**
   * Set user active.
   *
   * Activates or deactivates a user for login.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdSetActivePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usersUserIdSetActivePost$Response(params: UsersUserIdSetActivePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = usersUserIdSetActivePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Set user active.
   *
   * Activates or deactivates a user for login.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdSetActivePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usersUserIdSetActivePost(params: UsersUserIdSetActivePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.usersUserIdSetActivePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
